var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"region"},[_c('b-container',{staticClass:"mt-3",attrs:{"fluid":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }